import { makeStyles } from 'tss-react/mui';

const useStylesWidgetRow: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  widgetRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  widgetRowColumn: {
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'start',
    width: 'calc(50% - 10px)',
  },
}));

export default useStylesWidgetRow;
